import React, {Component} from "react";
import SVGImageLib from 'react-inlinesvg';
import "./SVGImage.css";

class SVGImage extends Component {

  render() {
    const {src} = this.props;
    return (
      <div className="fow-svg-image">
        <div className="fow-svg-image-inner">
          <SVGImageLib src={src} />
        </div>
      </div>
    );
  }
}

export default SVGImage;
